import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { auth, database } from "./firebaseConfig";
import { doc, getDoc, query, getDocs, collection } from "firebase/firestore";

export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const createUser = (email, password) => {
    setLoading(true);
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const loginUser = async (email, password) => {
    setLoading(true);
    try {
      return await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      setLoading(false)
    }

  };

  const logOut = () => {
    setLoading(true);
    return signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser != null) {
        const utilisateurs = await listeUsers()
        const userId = currentUser.uid ? currentUser.uid : null
        const userFilter = utilisateurs.filter((elem) => { return elem.user_uid == userId })
        currentUser.chu_id = null
        currentUser.type = null
        currentUser.chu_nom=null
        currentUser.user_id= null
        if (userFilter.length > 0) {
          currentUser.user_id= userFilter[0].id
          currentUser.chu_id = userFilter[0].chu_id ? userFilter[0].chu_id : null
          currentUser.type = userFilter[0].type ? userFilter[0].type : null
          if(userFilter[0].chu_id && userFilter[0].chu_id != null){
            const chus = await listeChus()
            const chuFilter = chus.filter((elem) => { return elem.id == userFilter[0].chu_id })
            currentUser.chu_nom=chuFilter[0].nom_chu ? chuFilter[0].nom_chu : null
            currentUser.chu_code=chuFilter[0].code_chu ? chuFilter[0].code_chu : null

          }

        }
      }
      setUser(currentUser);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);
  const listeUsers = async () => {
    const res = []
    const q = query(collection(database, 'utilisateur'))
    const user_refs = await getDocs(q);
    user_refs.forEach(utilisateur => {
      res.push({
        id: utilisateur.id,
        ...utilisateur.data()
      })
    })
    return res
  }
  const listeChus = async () => {
    const res = []
    const q = query(collection(database, 'chu'))
    const chu_refs = await getDocs(q);
    chu_refs.forEach(chu => {
      res.push({
        id: chu.id,
        ...chu.data()
      })
    })
    return res
  }

  const authValue = {
    createUser,
    user,
    loginUser,
    logOut,
    loading,
  };

  return <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;